namespace GeniuzPOS.Administration {
    export interface PsConfigForm {
        ShopId: Serenity.StringEditor;
        ConfigTypeId: Serenity.LookupEditor;
        ConfigCode: Serenity.StringEditor;
        ConfigDate: Serenity.DateEditor;
        Description: Serenity.StringEditor;
        LastUpdate: Serenity.DateEditor;
        UpdateBy: Serenity.StringEditor;
        IsActive: Serenity.BooleanEditor;
    }

    export class PsConfigForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.PsConfig';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsConfigForm.init)  {
                PsConfigForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.DateEditor;
                var w3 = s.BooleanEditor;

                Q.initFormType(PsConfigForm, [
                    'ShopId', w0,
                    'ConfigTypeId', w1,
                    'ConfigCode', w0,
                    'ConfigDate', w2,
                    'Description', w0,
                    'LastUpdate', w2,
                    'UpdateBy', w0,
                    'IsActive', w3
                ]);
            }
        }
    }
}
